export const LISTABLE_TYPES_MODELS = {
	'App\\Models\\Building': 'buildings',
	'App\\Models\\Client': 'clients',
	'App\\Models\\Lead': 'leads',
};

export const LISTABLE_TYPES = Object.values(LISTABLE_TYPES_MODELS).reduce((acc, type) => {
	acc[type] = type;
	return acc;
}, {});

export const LISTABLE_TYPES_ARRAY = Object.values(LISTABLE_TYPES_MODELS);
